import script from "./PayContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayContent.vue?vue&type=script&lang=ts&setup=true"

import "./PayContent.vue?vue&type=style&index=0&id=5cde3aa9&lang=scss"

const __exports__ = script;

export default __exports__